module.exports = __webpack_public_path__ + "static/media/instagram2.e3f7f532.svg";